import { useRouter, useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Toast, useSidebar } from '@whelk/components';
import { CHAT_ID, HOME_URL } from '@whelk/const/src/routerUrl';
import { AppDispatch, RootState } from '@whelk/store';
import { clearEditUserMsg, setIsShareSelecting } from '@whelk/store/slices/chatListSlice';
import { openLoginModal, trackCustomEvent } from '@whelk/utils';

import usePageName from '../usePageName';

const useChat = () => {
  const { t } = useTranslation();
  const nav = useRouter();
  const dispatch: AppDispatch = useDispatch();
  const { handleMobileClose } = useSidebar();
  const { getPageName } = usePageName();

  const isLogin = useSelector((state: RootState) => state.user.isLogin);
  const isShareSelecting = useSelector((state: RootState) => state.chat.isShareSelecting);
  const searchParams = useSearchParams();
  const selectedChatID = searchParams?.get(CHAT_ID) || '';

  const addNewChat = () => {
    if (!isLogin) {
      openLoginModal();
    }
    handleMobileClose();
    if (isShareSelecting) {
      dispatch(setIsShareSelecting(false));
    }
    trackCustomEvent({
      id: 'create_chat_click',
      page: getPageName(),
    });

    // 这里不能直接用pageType ，因为需要被挂载到window监听
    if (location?.pathname === HOME_URL && !location?.search) {
      Toast.info(t('toast_new_topic_started'));
      return;
    }
    // 清空问题编辑
    dispatch(clearEditUserMsg());
    nav.push(HOME_URL);
  };

  return {
    addNewChat,
    isNewChat: !selectedChatID,
  };
};
export { useChat };
